module.exports = __webpack_public_path__ + "media/Components/fonts/Monda-9131653018528b195d57fb8a79fc4e9e.ttf";